import React from "react";
import { Video } from "@telia/teddy";
import { Modal } from "../../../../models";
import SubscriptionTextBlock from "../../components/components/molecules/SubscriptionTextBlock/SubscriptionTextBlock";
import LogoGrid from "../../fwa/components/molecules/LogoGrid/LogoGrid";
import ModalSellingPoints from "../../fwa/components/molecules/ModalSellingPoints/ModalSellingPoints";

export const RenderCfContent: React.FC<{ modal: Modal }> = ({ modal }) => {
    return (modal.blocks || []).map((block, index: number) => {
        switch (block.__type) {
            case "TextBlock":
                return (
                    <SubscriptionTextBlock
                        headingSize="xs"
                        headingTag="h3"
                        key={`${modal.forEntryId}_${index}`}
                        textBlock={block}
                    />
                );
            case "USPList":
                return <ModalSellingPoints sellingPoints={block.sellingPoints} />;
            case "YouTubeVideo":
                return (
                    <Video
                        key={block.videoId}
                        src={`https://www.youtube.com/embed/${block.videoId}`}
                        description={block.description}
                        allowFullScreen
                    />
                );
            case "LogoGrid":
                return <LogoGrid {...block} />;
            default:
                return null;
        }
    });
};
